import { useCallback, useRef } from 'react';

export type WregScreenEvent = (event: string, properties?: Record<string, unknown>) => void;

export type WregInvalidityReason = 'format' | 'out_of_range' | 'mismatch';

export type WregScrollDirection = 'up' | 'down';

export const useWregScrollDirection = (onDirection: (direction: WregScrollDirection) => void) => {
  const last = useRef<{ top: number; direction?: WregScrollDirection }>({ top: 0 });
  return useCallback(
    (el: HTMLElement) => {
      const top = el.scrollTop;
      const previous = last.current;
      if (top === previous.top) return;
      const direction: WregScrollDirection = top > previous.top ? 'down' : 'up';
      last.current = { top, direction };
      if (direction !== previous.direction) onDirection(direction);
    },
    [onDirection],
  );
};
